import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Category } from '@core/domain/models/category.models';
import { MediasPublicConstants } from '@features/products/medias';
import { CategoryConfiguration, ProductViewConfig, ProductViewPlace } from '@shared/product/models';

@Component({
    selector: 'app-grid-default-3',
    templateUrl: './grid-default-3.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridDefault3Component implements OnInit {
    @Input() public defaultImageTypes: Map<number, string>;

    @Input() public category: Category;

    @Input() public isCategoryNew: boolean;

    @Input() public productIds: number[];

    @Input() public place: ProductViewPlace;

    @Input() public seoCategoryName: string;

    @Input() public showMediaCarousel: boolean;

    @Input() public showLastSizesGrid: boolean;

    @Output() public readonly loadNextPageEvent: EventEmitter<void> = new EventEmitter();

    public templateConfiguration: ProductViewConfig;

    public categoryConfiguration: CategoryConfiguration; // Product View deberia recibir solo la TemplateConfiguration

    public ngOnInit(): void {
        this.categoryConfiguration = {
            soldOut: false,
            productConf: new Map(),
            category: this.category,
            isCategoryNew: this.isCategoryNew,
        };
        this.templateConfiguration = {
            media: {
                ratio: '3-4',
                widthVW: '(max-width: 800) 50vw, 25vw',
                showWaterMark: false,
            },
            location: MediasPublicConstants.PublicMediaLocationType.ZOOM_3,
            place: this.place,
            discardDoubleVideo: true,
            discardFallback: true,
            showDetails: false,
            showQuickly: false,
            showMediaCarousel: this.showMediaCarousel,
            // eslint-disable-next-line no-secrets/no-secrets
            set: 0, // https://jira.inditex.com/jira/browse/ITSMECOM-3554928 (hardcoded 0)
        };
    }

    public onScroll(): void {
        this.loadNextPageEvent.emit();
    }
}
